//let getApi = () => import('@/services/Api');

const state = {
	selectedEmployee: null,
};

const getters = {
	getQuickEmployee: (state) => state.selectedEmployee,
	quickSelected: (state) => !!state.selectedEmployee,

};
const actions = {
	storeSelectedEmployee({commit}, payload) {
		commit('setSelectedEmployee', payload)
	},

};
const mutations = {
	setSelectedEmployee: (state, value) => {
		state.selectedEmployee = value
	},

};

export default {
	state,
	getters,
	actions,
	mutations
}